export type PlayerMode = "AUTO" | "NATIVE" | "HLS.JS"

export type SneakPeekList = { [_: string]: SneakPeek }
export type SneakPeek = {
  reason: "NOT_LOGIN_SNEAK_PEEK" | "NOT_SUBSCRIBER_SNEAK_PEEK",
  createdAt: number
}

export class Mag2LocalStorage {

  private static keyUserId: string = "USER_ID";
  private static keyClientId: string = "CLIENT_ID";
  private static keyPlayerMode: string = "PLAYER_MODE";
  private static keySneakPeeks: string = "SNEAK_PEEKS";

  static getUserId(): number | null {
    const userId = localStorage.getItem(this.keyUserId);
    if (userId === null) {
      return null;
    }
    return parseInt(userId, 10);
  }

  static setUserId(userId: number | undefined | null) {
    if (userId === undefined || userId === null || isNaN(userId)) {
      this.removeUserId();
    } else {
      localStorage.setItem(this.keyUserId, userId.toString());
    }
  }

  static removeUserId() {
    localStorage.removeItem(this.keyUserId)
  }

  static getClientId(): string | null {
    const clientId = localStorage.getItem(this.keyClientId);
    if (clientId === null) {
      return null;
    }
    return clientId;
  }

  static setClientId(clientId: string | undefined | null) {
    if (clientId === undefined || clientId === null) {
      this.removeClientId()
    } else {
      localStorage.setItem(this.keyClientId, clientId);
    }
  }

  static removeClientId() {
    localStorage.removeItem(this.keyClientId)
  }

  static getPlayerMode(): PlayerMode {
    const playerMode = localStorage.getItem(this.keyPlayerMode);
    if (playerMode === null) {
      return "AUTO";
    }
    switch (playerMode) {
      case "AUTO":
      case "NATIVE":
      case "HLS.JS":
        return playerMode;
      default:
        this.removePlayerMode();
        return "AUTO";
    }
  }

  static setPlayerMode(playerMode: PlayerMode | undefined | null) {
    if (playerMode === undefined || playerMode === null) {
      this.removePlayerMode();
    } else {
      localStorage.setItem(this.keyPlayerMode, playerMode);
    }
  }

  static removePlayerMode() {
    localStorage.removeItem(this.keyPlayerMode)
  }

  private static getSneakPeekList(): SneakPeekList | null {
    const sneakPeeks = localStorage.getItem(this.keySneakPeeks);
    if (sneakPeeks === null) {
      return null;
    }
    // TODO 古すぎるものは削除して更新
    return JSON.parse(sneakPeeks);
  }

  static getSneakPeek(liveId: string): SneakPeek | null {
    const sneakPeekList = this.getSneakPeekList();
    if (sneakPeekList === null) {
      return null;
    }
    const sneakPeek = sneakPeekList[liveId];
    if (sneakPeek === undefined) {
      return null;
    }
    return sneakPeek;
  }

  static addSneakPeek(liveId: string, sneakPeek: SneakPeek) {
    const sneakPeekList = this.getSneakPeekList();
    if (sneakPeekList === null) {
      const map = {} as any;
      map[liveId] = sneakPeek;
      localStorage.setItem(this.keySneakPeeks, JSON.stringify(map));
    } else {
      sneakPeekList[liveId] = sneakPeek;
      localStorage.setItem(this.keySneakPeeks, JSON.stringify(sneakPeekList));
    }
  }
}
